import { Grid, Box } from '@mui/material';
import HowItWorks from '../../../ui-utils/latestPics/how_it_works.svg';


import { useLanguage } from "../../../Context/LangContext";
const WebView = () => {
  const { language } = useLanguage();
  const headingTranslations = {
     en: "How it works",
    "hi": "कैसे काम करता है",
    "kn": "ಹೇಗೆ ಕೆಲಸ",
    "ma": "कसे कार्य",
    "gu": "કેમ કાર્ય કરે"
  };
  return (
    <Box sx={{ backgroundColor: '#FFF6EE', width: '100%', paddingBottom: 8 }}>
      {/* Main Heading */}
      <Grid
        sx={{
          paddingTop: '40px',
          paddingBottom: '20px',
          display: 'flex',
          justifyContent: 'center',
          flexDirection: 'column',
          textAlign: 'center',
        }}
      >
        <h1 style={{ fontSize: "calc(40px + var(--font-delta))", lineHeight: "56px", fontFamily: "Inter500", letterSpacing: "0px", color:"#3E3E3E"}}>{headingTranslations[language] || headingTranslations.en}</h1>
      </Grid>

      {/* Responsive Image Section */}
      <Box
        sx={{
          backgroundColor: '#FFF6EE',
          maxWidth: '1600px',
          margin: '30px auto 0px',
          width: '100%',
          boxSizing: 'border-box',
          px: { xs: 2, sm: 4 },
          display: 'flex',
          justifyContent: 'center',
        }}
      >
        <Box
          component="img"
          src={HowItWorks}
          alt="How it works illustration"
          sx={{
            width: '100%',
            height: 'auto',
            objectFit: 'contain',
          }}
        />
      </Box>
    </Box>
  );
};

export default WebView;
